import React from "react"
import FieldView from "../../../../render/view";
import {FieldManagementPreviewProps} from "../../../../render/management-preview";

export default function FieldEmail_ManagementPreview(props: FieldManagementPreviewProps) {


    const model:any = {}
    model[props.field.fieldId] = "alex.kim@acme.com"

    return <FieldView field={props.field} model={model} />


}